import * as ActionTypes from "../Types/ActionTypes";

export const Projects = (
  state = {
    isLoading: false,
    errMess: null,
    projects: [],
    projectid: [],
    projectPhotograph: [],
    isSubmited: false,
    // productorder: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_PROJECTS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        projects: action.payload,
      };
    case ActionTypes.FETCH_PROJECTS_PHOTOGRAPH:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        projectPhotograph: action.payload,
      };

    // case ActionTypes.FETCH_PRODUCTORDER:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     errMess: null,
    //     productorder: action.payload,
    //   };

    // case ActionTypes.FETCH_PRODUCTID:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     errMess: null,
    //     projectid: action.payload,
    //   };

    case ActionTypes.PROJECTS_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        projects: [],
      };
    case ActionTypes.PROJECTS_LOADING2:
      return {
        ...state,
        isLoading2: true,
        errMess: null,
        projectid: [],
      };

    case ActionTypes.PROJECTS_LOADING_FALSE:
      return {
        ...state,
        isLoading: false,
        errMess: null,
      };

    case ActionTypes.PROJECTS_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        projects: [],
      };
    case ActionTypes.PROJECTS_LOADING_Id:
      return {
        ...state,
        projectid: [],
        isSubmited:false
      };
    case ActionTypes.FETCH_PROJECTS_ID:
      return {
        ...state,
        isLoading: false,
        isLoading2: false,
        projectid: action.payload,
        isSubmited:true
      };

    default:
      return state;
  }
};
